import { Action, Dispatch } from 'redux'
import { selectTopTabAction } from 'reducks/auth/actions'

const selectTopTab = (nextTab: 'hand_over' | 'delivery') => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(selectTopTabAction(nextTab))
  }
}

export default selectTopTab
